import PropTypes from 'prop-types';

export const API_CLIENT__START_REQUEST = 'API_CLIENT__START_REQUEST';
export const API_CLIENT__END_REQUEST = 'API_CLIENT__END_REQUEST';
export const API_CLIENT__ERROR = 'API_CLIENT__ERROR';
export const API_CLIENT__RESET = 'API_CLIENT__RESET';

export const API_CLIENT__SHAPE = PropTypes.shape({
  lastError: PropTypes.shape(),
  isLoading: PropTypes.bool,
  requests: PropTypes.shape(),
});
